import { Button, Classes, Icon, Popover } from '@blueprintjs/core';
import { formatDatetime } from '../../utils/formatDate';
import styles from './DateTimePicker.module.css';
import { DatePicker3, DatePicker3Props } from '@blueprintjs/datetime2';

export enum IDateFormatType {
  dateTimeLocal = 'datetime-local',
  date = 'date',
}

interface IDateTimePicker {
  value?: string;
  onChange?: (date: string) => void;
  buttonText?: string;
  type?: IDateFormatType;
  disabled?: boolean;
  dateInputProps?: Partial<DatePicker3Props>;
}

function removeTimeZone(date: string, type: IDateFormatType) {
  if (type === IDateFormatType.date) return date.slice(0, 10);
  else return date.slice(0, 16);
}

/**
 * @deprecated
 */
const DateTimePicker = ({
  value,
  onChange,
  buttonText,
  disabled,
  type = IDateFormatType.dateTimeLocal,
  dateInputProps,
}: IDateTimePicker) => {
  const isTimePicker = type === IDateFormatType.dateTimeLocal;

  const handleChange = (value: Date | null) => {
    if (value) {
      if (!isTimePicker) {
        const dateWithoutTimeZone = removeTimeZone(value.toISOString(), type);
        if (onChange) onChange(dateWithoutTimeZone);
      } else {
        if (onChange) onChange(value.toISOString());
      }
    } else {
      if (onChange) onChange('');
    }
  };

  return (
    <Popover
      popoverClassName={Classes.POPOVER_CONTENT_SIZING}
      placement="bottom"
      content={
        <DatePicker3
          className={styles.datePopover}
          onChange={handleChange}
          value={value ? new Date(value) : undefined}
          timePrecision={isTimePicker ? 'minute' : undefined}
          {...dateInputProps}
        />
      }
      onOpening={!value ? () => handleChange(new Date()) : undefined}
      renderTarget={({ isOpen: _, ...targetProps }) => (
        <Button
          {...targetProps}
          className={styles.datePicker}
          intent="warning"
          minimal
          disabled={disabled}
          text={
            value ? (
              <DateTimeDisplay
                disabled={disabled}
                value={value}
                excludeTime={!isTimePicker}
              />
            ) : (
              buttonText
            )
          }
        />
      )}
    />
  );
};

interface IDateTimeDisplay {
  value: string;
  hideIcon?: boolean;
  excludeTime?: boolean;
  disabled?: boolean;
}

export const DateTimeDisplay = ({
  value,
  hideIcon,
  excludeTime = false,
  disabled,
}: IDateTimeDisplay) => {
  return (
    <div className={styles.buttonContainer}>
      <span>{formatDatetime(value, excludeTime)}</span>
      {!hideIcon && !disabled && <Icon icon="caret-down" />}
    </div>
  );
};

export default DateTimePicker;
